// extracted by mini-css-extract-plugin
export var container = "bm_f";
export var downloadButtonContainer = "bm_db";
export var loadingContainer = "bm_b8";
export var section = "bm_d";